import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GalleryToggle } from '@o2web.ca/museum-viewer';

// Styles
import './styles.scss';

// Components
import Image from '../../../tools/image/Image';
import ImageGalleryThumbnail from './ImageGalleryThumbnail';

// Props
const propTypes = {
  artworkID: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  medias: PropTypes.array,
  updateImageContainerHeight: PropTypes.func.isRequired,
};

const defaultProps = {
  artworkID: false,
  medias: [],
};

const contextTypes = {
  initialRender: PropTypes.bool,
};

class ImageGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentMediaUrl: '',
      currentMediaAlt: '',
      currentMediaCredits: '',
    };
    this.images = [];
    this.videos = [];
    this.changeCurrentImage = this.changeCurrentImage.bind(this);
  }
  componentDidMount() {
    const { medias } = this.props;
    this.images = medias.filter((media) => (media.mediaType === 'image'));
    this.videos = medias.filter((media) => (media.mediaType === 'video'));
    if (this.images.length > 0) {
      this.changeCurrentImage(this.images[0]);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { currentMediaUrl: previousImageUrl } = prevState;
    const { currentMediaUrl } = this.state;
    const { updateImageContainerHeight } = this.props;
    if (previousImageUrl !== currentMediaUrl) {
      updateImageContainerHeight();
    }
  }
  changeCurrentImage({ url, alt, credits }) {
    this.setState({
      currentMediaUrl: url,
      currentMediaAlt: alt,
      currentMediaCredits: credits,
    });
  }
  render() {
    const { medias, updateImageContainerHeight, artworkID } = this.props;
    const { currentMediaUrl, currentMediaAlt, currentMediaCredits } = this.state;
    const { initialRender } = this.context;
    return (
      <div className="image-gallery">
        <div className="image-gallery__main">
          {artworkID && window && document && !initialRender &&
            <GalleryToggle
              className="image-gallery__enlarge"
              artworkID={artworkID}
              content=""
            />
          }
          <figure className="image-gallery__picture">
            <Image
              alt={currentMediaAlt}
              mediaUrl={currentMediaUrl}
              onLoad={() => updateImageContainerHeight()}
              placeholder="unavailable"
              key={currentMediaUrl}
            />
            <figcaption className="image-gallery__rights">
              {currentMediaCredits}
            </figcaption>
          </figure>
        </div>
        {medias.length > 1 &&
          <ul className="image-gallery__thumbnails">
            {this.images.concat(this.videos).map((media) =>
              <ImageGalleryThumbnail
                key={media.url}
                active={media.url === currentMediaUrl}
                changeCurrentImage={this.changeCurrentImage}
                media={media}
              />,
            )}
          </ul>
        }
      </div>
    );
  }
}

ImageGallery.propTypes = propTypes;
ImageGallery.defaultProps = defaultProps;
ImageGallery.contextTypes = contextTypes;

export default ImageGallery;



// WEBPACK FOOTER //
// ./src/app/components/singles/parts/imageGallery/ImageGallery.js